import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from '@AppCore/guard/auth-guard.service';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ReturnPolicyComponent } from './pages/return-policy/return-policy.component';
import { ShippingPolicyComponent } from './pages/shipping-policy/shipping-policy.component';
import { TermsServiceComponent } from './pages/terms-service/terms-service.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { TrackingComponent } from './pages/tracking/tracking.component';
const routes: Routes = [
  {
    path: '',
    component: MainPageComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'my-account',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('../../features-modules/user/user.module').then(
            (m) => m.UserModule
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('../../features-modules/products/products.module').then(
            (m) => m.ProductsModule
          ),
      },
      {
        path: 'blogs',
        loadChildren: () =>
          import('../../features-modules/blogs/blogs.module').then(
            (m) => m.BlogsModule
          ),
      },
      {
        path: 'about-us',
        component: AboutUsComponent,
      },
      {
        path: 'contact-us',
        component: ContactUsComponent,
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
      },
      {
        path: 'return-policy',
        component: ReturnPolicyComponent,
      },
      {
        path: 'shipping-policy',
        component: ShippingPolicyComponent,
      },
      {
        path: 'terms-service',
        component: TermsServiceComponent,
      },
      {
        path: 'faq',
        component: FaqsComponent,
      },
      {
        path: 'track',
        component: TrackingComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
